module.exports = __webpack_public_path__ + "static/img/download_b.30162ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download_b.jpg
// module id = 2qGQ
// module chunks = 1